import { render } from "./Forwarding.vue?vue&type=template&id=73a5f0fc&ts=true&lang=pug"
import script from "./Forwarding.vue?vue&type=script&setup=true&lang=ts"
export * from "./Forwarding.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__